<template>
  <div class="flex items-center sm:order-1 md:order-2 space-x-1 md:space-x-0 rtl:space-x-reverse">
    <button ref="dropdownToggleRef" type="button" data-dropdown-toggle="language-dropdown" aria-expanded="false" aria-hidden="true"
      class="inline-flex items-center font-medium justify-center px-4 py-2 text-sm text-white rounded-lg cursor-pointer">
      <div class="w-8 h-8 me-3 rounded-full overflow-hidden shadow-md hover:ring-4 hover:ring-paletteLightGreen">
        <img v-if="currentLanguage.flag" :src="currentLanguage.flag" class="w-full h-full object-cover">
      </div>
    </button>
    <!-- Dropdown -->
    <div
      class="z-50 hidden my-4 w-48 text-base list-none bg-paletteDarkGreen divide-y divide-paletteDarkGreen rounded-xl shadow-sm border border-gray-300" id="language-dropdown">
      <ul class="py-2 font-medium">
        <li v-for="(lang, country) in countryLanguageMap" :key="country">
          <a @click.prevent="changeLanguage(country)" href="#"
            class="block px-4 py-2 text-sm text-white hover:bg-paletteLightGreen">
            <div class="inline-flex items-center">
              <div class="w-3.5 h-3.5 me-2 rounded-full overflow-hidden shadow-md">
                <img v-if="lang.flag" :src="lang.flag" class="w-full h-full object-cover">
              </div>
              <span>{{ lang.name }}</span>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { initFlowbite } from 'flowbite'

import usFlag from '@/assets/svg/us.svg'
import ukFlag from '@/assets/svg/uk.svg'
import frFlag from '@/assets/svg/france.svg'
import deFlag from '@/assets/svg/germany.svg'
import esFlag from '@/assets/svg/spain.svg'
import itFlag from '@/assets/svg/italy.svg'

const { locale } = useI18n()

const countryLanguageMap = {
  US: { code: 'en', name: 'English (US)', flag: usFlag },
  UK: { code: 'en', name: 'English (UK)', flag: ukFlag },
  FR: { code: 'fr', name: 'Français', flag: frFlag },
  DE: { code: 'de', name: 'Deutsch', flag: deFlag },
  ES: { code: 'es', name: 'Español', flag: esFlag },
  IT: { code: 'it', name: 'Italiano', flag: itFlag }
}

// Find the country key whose code matches the current locale
function getCountryByLocale (localeCode) {
  return Object.keys(countryLanguageMap).find(
    country => countryLanguageMap[country].code === localeCode
  ) || 'US'
}

const currentLanguage = ref(countryLanguageMap[getCountryByLocale(locale.value)])
const dropdownToggleRef = ref(null)

const changeLanguage = (country) => {
  currentLanguage.value = countryLanguageMap[country]
  locale.value = countryLanguageMap[country].code
  // Hide the dropdown using Flowbite's Dropdown API (fallback to vanilla if needed)
  const dropdownMenuEl = document.getElementById('language-dropdown')
  if (dropdownMenuEl) {
    dropdownMenuEl.classList.add('hidden')
    dropdownMenuEl.classList.remove('block')
    // Also update aria attributes for accessibility
    const toggleBtn = dropdownToggleRef.value
    if (toggleBtn) {
      toggleBtn.setAttribute('aria-expanded', 'false')
    }
  }
}

onMounted(() => {
  // Sync currentLanguage with any runtime locale changes
  currentLanguage.value = countryLanguageMap[getCountryByLocale(locale.value)]
  initFlowbite()
})
</script>
